module.exports = __webpack_public_path__ + "static/img/contant_5.8276139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/contant_5.png
// module id = mY4D
// module chunks = 0